// User Info Form Item - Represents Form Item Name
export enum UserInfoFI {
  FirstName = "firstName",
  LastName = "lastName",
  Country = "country",
  Address = "address",
  PostalCode = "postalCode",
  City = "city",
  Email = "email",
  Phone = "phone",
  Note = "note",

  // checkbox
  IsCompany = "isCompany",

  // company fields
  CompanyName = "companyName",
  CompanyAddress = "companyAddress",
  CompanyVAT = "companyVAT",
  CompanyCountry = "companyCountry",
}
